// @flow
import {
  requestChannelStats,
  receiveChannelStats,
} from './channelStatsActions';
import { handleActions, type ActionType } from 'redux-actions';
import { Map } from 'immutable';

// type State = Map<string, Error | number>;
type State = {
  stats: Map<string, Error | number>,
  worklistStats: Map<string, Error | number>,
};
const defaultState: State = {
  stats: Map(),
  worklistStats: Map(),
};
export default handleActions(
  {
    [requestChannelStats.toString()]: (
      state: State,
      action: ActionType<typeof requestChannelStats>
    ) => defaultState,
    [receiveChannelStats.toString()]: (
      state: State,
      action: ActionType<typeof receiveChannelStats>
    ) => {
      if (action.error === true) {
        const { channelName, worklist } = action.meta;

        if (worklist) {
          return {
            ...state,
            worklistStats: state.worklistStats.set(channelName, action.payload),
          };
        } else {
          return {
            ...state,
            stats: state.stats.set(channelName, action.payload),
          };
        }
      }

      if (action.meta.worklist) {
        return {
          ...state,
          worklistStats: state.worklistStats.merge(action.payload),
        };
      } else {
        return {
          ...state,
          stats: state.stats.merge(action.payload),
        };
      }
    },
  },
  defaultState
);



// WEBPACK FOOTER //
// ./src/containers/channels/channelStatsReducer.js